import React from 'react'
import { Layout, Header, Intro } from '../../../../components'

import Changelog from './changelog'

import data from './data.json'
import './style.scss'

export default () => {
  return (
    <>
      <Header
        slug={data.slug + '/develop/'}
        site={data.site}
        state="develop"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            All changes and revisions to M&T Currency will be documented here.
            For specific questions or issues with updating,{' '}
            <a class="link" href="mailto:currencydesignsytem@mtb.com">
              please reach out to us
            </a>
          </p>
        </Intro>
        <Changelog></Changelog>
      </Layout>
    </>
  )
}
